export enum FormProfileTypeEnum {
  Entire = 'EntireProfile',
  Company = 'CompanyProfile',
  Offer = 'OtherProfile',
}
